<template>
  <div>
    <div v-if="showBanner" id="cookiebar-container" class="py-3 py-md-4">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <div class="cookie-content">
              <div>
                <p>
                  {{ $i18n.cookieBanner.text1 }}
                </p>
                <p>
                  {{ $i18n.cookieBanner.text2 }}
                </p>
              </div>
              <div class="cookie-options">
                <button
                  type="button"
                  class="btn btn-outline-light btn-preferences"
                  @click="openPreferences"
                >
                  {{ $i18n.cookieBanner.preferences }}
                </button>
                <button
                  id="cookie-accept-button"
                  type="button"
                  class="btn btn-success"
                  @click="onConsent"
                >
                  {{ $i18n.cookieBanner.OK }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="showModal">
      <template #default>
        <h4 class="mt-2 mb-4">{{ $i18n.cookieBanner.modalTitle }}</h4>
        <div>
          <div
            v-for="(level, index) in levels"
            :key="index"
            :class="`d-flex flex-row justify-content-between align-items-center mx-n3 px-3 border-bottom ${
              index === 0 ? 'border-top' : ''
            }`"
          >
            <div class="mt-3 pe-4">
              <strong>{{ level.title }}</strong>
              <br />
              <p>{{ level.text }}</p>
            </div>
            <div>
              <InputSwitch
                :id="`switch-${index}`"
                v-model="level.checked"
                size="lg"
                :disabled="level.disabled"
                @input="onInput"
              />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div
          class="w-100 d-flex flex-row justify-content-between align-items-center pt-0 px-3 pb-3"
        >
          <p class="mb-0">
            {{ $i18n.cookieBanner.readMore }}
            <a :href="$i18n.cookieBanner.privacyPolicyLink" target="_blank">{{
              $i18n.cookieBanner.privacyPolicy
            }}</a>
          </p>
          <button type="button" class="btn btn-primary m-0" @click="onSave">
            {{ $i18n.cookieBanner.savePreferences }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import InputSwitch from './InputSwitch.vue';
import Modal from './Modal.vue';

export default {
  components: {
    InputSwitch,
    Modal,
  },
  props: {
    banner: {
      type: Boolean,
      default: true,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    consentLevels: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showBanner: this.banner,
      showModal: false,
      levels: this.consentLevels.map(
        ({ id, name, defaultValue, disabled }) => ({
          id,
          title: this.$i18n.cookieBanner[name + 'Title'],
          text: this.$i18n.cookieBanner[name + 'Text'],
          checked: defaultValue,
          disabled: disabled,
        })
      ),
    };
  },
  created() {
    if (this.modal) {
      this.openPreferences();
    }
  },
  methods: {
    openPreferences() {
      this.showModal = true;
    },
    openBanner() {
      this.showBanner = true;
    },
    onConsent() {
      this.$emit('consent', true);
      this.close();
    },
    onSave() {
      this.$emit(
        'consent',
        false,
        this.levels.filter(l => l.checked).map(l => l.id)
      );
      this.close();
    },
    close() {
      this.showBanner = false;
      this.showModal = false;
    },
  },
};
</script>
